// extracted by mini-css-extract-plugin
export default {"container":"headerServices_container__ylxfK","partImage":"headerServices_partImage__meLkj","orderService":"headerServices_orderService__1KIDc","icon":"headerServices_icon__VGRuc"};